import { render, staticRenderFns } from "./OrderArchiveButton.vue?vue&type=template&id=180b8feb&scoped=true&"
import script from "./OrderArchiveButton.vue?vue&type=script&lang=js&"
export * from "./OrderArchiveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b8feb",
  null
  
)

export default component.exports